// Suche ueber den vorgebauten Index (buildSearchIndex bleibt in app.jsx, an TOPIC_ORDER gekoppelt).
// Reine Funktion: (query, index) -> { thinkers, terms }.
export function search(query, index) {
  const q = query.toLowerCase().trim();
  if (!q) return { thinkers: [], terms: [] };
  const thinkers = index.thinkers
    .filter(t => t.label.toLowerCase().includes(q) || t.title.toLowerCase().includes(q))
    .sort((a, b) => {
      const posA = Math.min(
        ...[a.label, a.title].map(s => { const i = s.toLowerCase().indexOf(q); return i === -1 ? Infinity : i; })
      );
      const posB = Math.min(
        ...[b.label, b.title].map(s => { const i = s.toLowerCase().indexOf(q); return i === -1 ? Infinity : i; })
      );
      return posA - posB;
    })
    .slice(0, 5);
  const terms = index.terms
    .filter(t => t.term.toLowerCase().includes(q))
    .sort((a, b) => a.term.toLowerCase().indexOf(q) - b.term.toLowerCase().indexOf(q))
    .slice(0, 8);
  return { thinkers, terms };
}
